export default Object.freeze({
  giftCardCanOnlyBeUsedToCoverAssignedBarberAmount: 101,
  giftCardInsufficientFunds: 102,
});
